import type { AxiosProgressEvent } from 'axios'

import { injectCompanyToURL } from '@helpers'

import Api from '../api'
import type { FetchCompanyDocumentsPayload, RemoveCompanyDocumentPayload } from './types'
import { API_COMPANY_DOCUMENT_URL, API_COMPANY_DOCUMENTS_URL } from './urls'

export function fetchCompanyDocuments(companyId: Company['id'], params: FetchCompanyDocumentsPayload) {
  return Api.get<BackendCompanyDocumentListResults>(injectCompanyToURL(API_COMPANY_DOCUMENTS_URL, companyId), {
    params,
  })
}

//* the endpoint accepts a single file per request in a "document" field
export function uploadCompanyDocument(
  companyId: Company['id'],
  file: File,
  onUploadProgress?: (event: AxiosProgressEvent) => void
) {
  return Api.post<BackendCompanyDocument>(
    injectCompanyToURL(API_COMPANY_DOCUMENTS_URL, companyId),
    { document: file },
    {
      onUploadProgress,
      timeout: 5 * 60000, // 5 * 60sec
      transformRequest: [
        function (data) {
          const formData = new FormData()
          formData.append('document', data.document)
          return formData
        },
      ],
    }
  )
}

export function removeCompanyDocument(companyId: Company['id'], { documentId }: RemoveCompanyDocumentPayload) {
  return Api.delete(
    injectCompanyToURL(API_COMPANY_DOCUMENT_URL, companyId).replace('{document_id}', String(documentId))
  )
}
